import React, { Component, Fragment } from 'react';
import { PATHS, DETAIL_ACTIONS, FEATURE_FLAGS } from "../../../../../constants/Define";
import * as HMS from "../../../common/component/Index";
import * as Func from '../../../../../helpers/functions';
import TranslateButton from '../../../common/component/TranslateButton';
import { isEqual, get, cloneDeep, find } from 'lodash';
import Wrapper from './../../../common/component/Wrapper';
import Input from "../../../common/component/Input";
import { checkUndefine } from "../../../../../helpers/functions";
import FareRule from '../../../../../models/FareRule';
// import './SideInfoDetail.less';

const defaultState = {
    action: DETAIL_ACTIONS.CREATE,
    validation: {},
    isGetItem: false
};

class FareRuleDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            isSubmit: false,
            fareRule: this.props.fareRuleState.detail.fareRule
        }
    }

    componentDidMount() {
        this.initDetail()
    }


    initDetail() {
        const { match } = this.props;
        if (Object.keys(match.params).length > 0 && match.params.id) {
            const id = match.params.id;
            this.setState({ action: DETAIL_ACTIONS.UPDATE });
            this.props.getFareRuleDetail(id);
        }
    }

    componentWillUnmount() {
        this.props.setFareRuleDetail(new FareRule())
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.fareRuleState.detail.fareRule && !isEqual(nextProps.fareRuleState.detail.fareRule, this.props.fareRuleState.detail.fareRule)) {
            this.setState({ fareRule: nextProps.fareRuleState.detail.fareRule, action: nextProps.fareRuleState.detail.fareRule.id ? 'UPDATE' : this.state.action });
        }
    }

    render() {
        const { t } = this.props;
        const { action, isSubmit, validation, isGetItem, fareRule } = this.state;

        return (
            <Fragment>
                <HMS.LoadingComponent spinning={isSubmit}>
                    <HMS.PageListComponent className="fare-rule-detail-page fix-pd-wrapper-form">
                        <HMS.HeaderListComponent
                            path={this.props.match.path}
                            groupPath={'fareRules'}
                            titleHeader={
                                action === "CREATE" ?
                                    Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.fareRule.title')}`).toLowerCase())
                                    : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.fareRule.title')}`.toLowerCase()))
                            }
                            componentRight={FEATURE_FLAGS.TRANSLATE_ENABLE &&
                                <TranslateButton
                                    languages={fareRule.translations}
                                    current={fareRule.languageCode}
                                    validation={validation.languageCode}
                                    onChange={this.onShowTranslate}
                                    onClear={this.onExitTranslate}
                                    defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                                    onSelectDefault={language => this.onChange('languageCode', language.code)}
                                    onRemove={this.onRemoveTranslate} />
                            }
                        />
                        <HMS.FormActionComponent
                            onSubmit={this.onSubmit}
                            isSubmit={isSubmit}
                            action={action}
                            isGetItem={isGetItem}
                            onClickBack={this.onClickBack}
                            backButtonText={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.cancel`) : t(`action.back`)}
                            titleButtonSubmit={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.save`) : undefined}
                            onChangeActive={e => this.onChangeDetail(e.name, e.value)}
                            submitButtonRight={true}
                            statusActiveName={`isActive`}
                        >
                            <Wrapper className='col-md-12 basic-section'>
                                <HMS.FormWrapperItem>
                                    <HMS.FormWrapperInputComponent
                                        className="col-md-6"
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={fareRule.airlineCode}
                                        validation={validation.airlineCode}
                                        labelTitle={t(`item.fareRule.airlineCode`)}
                                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                    >
                                        <Input placeholder="" type={`text`}
                                            className={`form-control`}
                                            name={`airlineCode`} onChange={(e) => this.onChange('airlineCode', e.target.value)}
                                            value={checkUndefine(fareRule.airlineCode)} />
                                    </HMS.FormWrapperInputComponent>
                                    <HMS.FormWrapperInputComponent
                                        className="col-md-6"
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={fareRule.className}
                                        validation={validation.className}
                                        labelTitle={t(`item.fareRule.className`)}
                                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                    >
                                        <Input placeholder="" type={`text`}
                                            className={`form-control`}
                                            name={`className`} onChange={(e) => this.onChange('className', e.target.value)}
                                            value={Func.checkUndefine(fareRule.className)} />
                                    </HMS.FormWrapperInputComponent>
                                    <HMS.FormWrapperInputComponent
                                        className="col-md-6"
                                        labelTitle={t(`item.fareRule.cancellationRefund`)}
                                    >
                                        <Input.TextArea rows={3} placeholder="" type={`text`}
                                            className={`form-control`}
                                            name={`cancellationRefund`} onChange={(e) => this.onChange('cancellationRefund', e.target.value)}
                                            value={Func.checkUndefine(fareRule.cancellationRefund)} />
                                    </HMS.FormWrapperInputComponent>
                                    <HMS.FormWrapperInputComponent
                                        className="col-md-6"
                                        labelTitle={t(`item.fareRule.timeChange`)}
                                    >
                                        <Input.TextArea rows={3} placeholder="" type={`text`}
                                            className={`form-control`}
                                            name={`timeChange`} onChange={(e) => this.onChange('timeChange', e.target.value)}
                                            value={Func.checkUndefine(fareRule.timeChange)} />
                                    </HMS.FormWrapperInputComponent>
                                    <HMS.FormWrapperInputComponent
                                        className="col-md-6"
                                        labelTitle={t(`item.fareRule.itineraryChange`)}
                                    >
                                        <Input.TextArea rows={3} placeholder="" type={`text`}
                                            className={`form-control`}
                                            name={`itineraryChange`} onChange={(e) => this.onChange('itineraryChange', e.target.value)}
                                            value={Func.checkUndefine(fareRule.itineraryChange)} />
                                    </HMS.FormWrapperInputComponent>
                                    <HMS.FormWrapperInputComponent
                                        className="col-md-6"
                                        labelTitle={t(`item.fareRule.passengerInfoChange`)}
                                    >
                                        <Input.TextArea rows={3} placeholder="" type={`text`}
                                            className={`form-control`}
                                            name={`passengerInfoChange`} onChange={(e) => this.onChange('passengerInfoChange', e.target.value)}
                                            value={Func.checkUndefine(fareRule.passengerInfoChange)} />
                                    </HMS.FormWrapperInputComponent>
                                    <HMS.FormWrapperInputComponent
                                        className="col-md-6"
                                        labelTitle={t(`item.fareRule.remarks`)}
                                        dataValidation={fareRule.remarks}
                                        validation={validation.remarks}
                                    >
                                        <Input.TextArea rows={3} placeholder="" type={`text`}
                                            className={`form-control`}
                                            name={`remarks`} onChange={(e) => this.onChange('remarks', e.target.value)}
                                            value={Func.checkUndefine(fareRule.remarks)} />
                                    </HMS.FormWrapperInputComponent>
                                </HMS.FormWrapperItem>
                            </Wrapper>
                        </HMS.FormActionComponent>
                    </HMS.PageListComponent>
                </HMS.LoadingComponent>
            </Fragment>
        )
    }

    onSaveTranslate = () => {
        const { fareRule } = this.state;
        const translateFunction = fareRule.translate.id ? this.props.updateFareRuleTranslate : this.props.createFareRuleTranslate;
        translateFunction(fareRule, fareRule.languageCode);
        this.onExitTranslate();
    }

    onChange = (fieldName, value) => {
        const fareRule = this.state.fareRule;
        const keyString = value;
        fareRule[fieldName] = keyString.trimLeft();
        this.setState({ fareRule });
    };

    onSubmit = (e) => {
        e.preventDefault();
        const { fareRule, action } = this.state;
        if (this.validate()) {
            if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
                this.onSaveTranslate()
            } else if (action === DETAIL_ACTIONS.CREATE) {
                this.props.createFareRuleDetail(fareRule)
            } else {
                this.props.updateFareRuleDetail({ fareRule, props: this.props })
            }
        }
    }

    convertStringKey = (value) => {
        const convertedString = Func.vietnameseStringToUnicode(value)
        return convertedString
    }

    validate() {
        const { t } = this.props;
        let validate = {
            maxLength: { airlineCode: Func.formatValidation(t('validation.statusCode.code.4'), 2) },
            required: {
                airlineCode: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.fareRule.airlineCode`)),
                className: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.fareRule.className`))
            }
        };
        if (this.state.action === DETAIL_ACTIONS.CREATE) {
            validate.required.languageCode = Func.formatValidation(t('validation.statusCode.code.1'), t(`translate.defaultLanguage`));
        }
        let valueValidate = {
            maxLength: { airlineCode: 2 }
        };
        const result = Func.multipleValidate(this.state.fareRule, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

    onClickBack = () => {
        if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
            this.onExitTranslate();
        } else {
            this.props.history.push(PATHS.FARE_RULES.LIST.path);
        }
    }

    onShowTranslate = (language) => {
        const { fareRule } = this.state;
        fareRule.setTranslate(language.code);
        fareRule.setData();
        this.setState({ fareRule, action: DETAIL_ACTIONS.TRANSLATE });
    }

    onExitTranslate = () => {
        const fareRule = cloneDeep(this.state.fareRule);
        const action = DETAIL_ACTIONS[fareRule.id ? 'UPDATE' : 'CREATE'];
        fareRule.setTranslate(undefined, true);
        fareRule.setData();
        this.setState({ fareRule, action });
    }

    onSaveTranslate = () => {
        const { fareRule } = this.state;
        const translateFunction = fareRule.translate.id ? this.props.updateFareRuleTranslate : this.props.createFareRuleTranslate;
        translateFunction(fareRule, fareRule.languageCode);
        this.onExitTranslate();
    }

    onRemoveTranslate = (language) => {
        const { fareRule } = this.state;
        fareRule.setTranslate(language.code);
        this.props.deleteFareRuleTranslate(fareRule, { id: fareRule.id });
    }
}

export default FareRuleDetail;
